"use client";

import { useIsShopsite } from "@context/DomainContext";
import { joinClassNames } from "@utils/helpers";
import { HTMLAttributes } from "react";
import { Skeleton as RadixSkeleton } from "@radix-ui/themes";

interface Props {
  className?: string;
  sharedClasses?: string;
  shopsiteClasses?: string;
  whitelabelClasses?: string;
}

/**
 * Primary UI wrapper component for skeleton loading. This is primarily used as visual placeholders for information while data is still loading
 *
 */
const Skeleton = ({
  className = "",
  sharedClasses = "",
  shopsiteClasses = "",
  whitelabelClasses = "",
  ...props
}: React.ComponentPropsWithoutRef<typeof RadixSkeleton> &
  Props &
  HTMLAttributes<HTMLDivElement>) => {
  const isShopsite = useIsShopsite();

  return isShopsite ? (
    <div
      className={joinClassNames(
        "animate-pulse bg-gray-100",
        className,
        sharedClasses,
        shopsiteClasses
      )}
      {...props}
    />
  ) : (
    <RadixSkeleton
      className={joinClassNames(className, sharedClasses, whitelabelClasses)}
      {...props}
    />
  );
};

export default Skeleton;
